import {JsonApiParams} from '@tisa-group/cdk';
import {Observable} from 'rxjs';
import {UmpireHeroItem} from '../umpire-hero-item';

export abstract class UmpireHeroService {
  abstract searchPlaceholder: string;

  abstract fetchList(params?: JsonApiParams): Observable<UmpireHeroItem[]>;

  abstract fetch(id: string): Observable<UmpireHeroItem>;
}
